<div class="container-fluid" >
    <div class="row">

        <!-- Sidebar -->

        <div class="col-12 col-md-2 color-primario-fondo color-alternativo-letra vh-sidebar custom-shadow ">

            <div class="row align-items-center justify-content-center">

                <div class="col col-md-12 m-auto ocultar py-3">
                    <img src="assets/logotipos/universidad-surcolombiana-ocre-horizontal-b.png"
                        alt="universidad-surcolombiana-ocre-horizontal-b.png" width="100%">
                </div>

                <hr class="ocultar " />
                
                <div class="col col-md-12 m-auto py-2 text-center">
                    <img [src]="(avatar === '' ? 'assets/imagenes/avatar.png': avatar)" alt="avatar.png"
                        class="rounded-circle shadow" width="60%">
                </div>

                <div class="col col-md-12 m-auto py-3 ocultar text-center">
                    {{credenciales?.nombre}}
                    {{credenciales?.apellido}}
                    
                </div>

                <div class="col col-md-12 m-auto py-3 ocultar text-center">
                    {{perfil?.gru_id}}
                </div>

                <hr class="ocultar " />
                
                <div class="col col-md-12 m-auto pointer text-start py-2" (click)="onClickNavigate('/menu-perfil')"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="Inicio">
                    <i class="bi bi-person-circle mr-icons"></i> <span class="ocultar">Perfil</span>
                </div>

                <hr class="ocultar " />
                
                <div class="col col-md-12 m-auto pointer text-start py-2" (click)="onClickNavigate('/menu-certificaciones')"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="Inicio">
                    <i class="bi bi-menu-button-wide-fill mr-icons"></i> <span class="ocultar">Certificados</span>
                </div>
                
                <hr class="ocultar " />

                <div class="col col-md-12 m-auto pointer text-start py-2" (click)="onClickLogout()" data-bs-toggle="tooltip"
                    data-bs-placement="top" title="Salir">
                    <i class="bi bi-x-circle-fill mr-icons"></i> <span class="ocultar">Salir</span>
                </div>

            </div>

        </div>

        <!-- Main -->

        <div class="col-12 col-md-10 vh-main">
            <router-outlet></router-outlet>
        </div>

    </div>
</div>